import { InfoHeader, useStyles } from '@layouts/academy/academy.styles'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import React from 'react'
import PropTypes from 'prop-types'

const Header = ({ academy }) => {
  const { name, logoImageUrl } = academy
  const classes = useStyles()
  return (
    <InfoHeader className={classes.infoHeader}>
      <Box className={classes.logoWrapper}>
        <img src={logoImageUrl} height="auto" alt={name} />
      </Box>
      <Box className={classes.titleWrapper}>
        <Typography variant="h2" color="secondary">{name}</Typography>
      </Box>
    </InfoHeader>
  )
}

export default Header

Header.propTypes = {
  academy: PropTypes.shape({
    name: PropTypes.string.isRequired,
    logoImageUrl: PropTypes.string.isRequired,
  }),
}
